import { YouTubeEmbedProps } from 'libs/contentful/props';

const YouTubeEmbed = ({ youTubeVideoUrl }: YouTubeEmbedProps) => {
  // Get video ID from URL
  const videoId = youTubeVideoUrl.split('v=')[1];

  // Validate video ID
  if (!videoId || !videoId.match(/^[a-zA-Z0-9_-]{11}$/)) {
    return null;
  }

  const embedUrl = `https://www.youtube.com/embed/${videoId}`;

  return (
    <span className="block my-11 aspect-video">
      <iframe
        width="100%"
        height="100%"
        src={embedUrl}
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen></iframe>
    </span>
  );
};

export default YouTubeEmbed;
